import { Formik } from "formik";
import * as React from "react";
import * as yup from "yup";
import styled from "styled-components";

import {
  Form,
  IFormField
} from "src/library/components/Forms";
import Grid from "src/library/components/Hedron";
import { Layout } from "src/core/shared/components/Layout";
import { useUserApi } from "src/core/users/api/users.api";
import { PageProps } from "src/pages/Router/routes";
import { e164PhoneRegex } from "src/utils/validation/regex";

const createUserForm = (): IFormField[] => [
  {
    type: "input",
    name: "firstName",
    label: "First Name",
    placeholder: "First Name",
    validation: yup
      .string()
      .min(1)
      .required("First Name is required")
  },
  {
    type: "input",
    name: "lastName",
    label: "Last Name",
    placeholder: "Last Name",
    validation: yup
      .string()
      .min(1)
      .required("Last Name is required")
  },
  {
    type: "input",
    name: "email",
    label: "Email",
    placeholder: "Email",
    validation: yup
      .string()
      .email("Please enter a valid email address")
      .required("Email is required")
  },
  {
    type: "input",
    name: "phoneNumber",
    label: "Phone Number",
    placeholder: "Phone Number",
    validation: yup
      .string()
      .matches(e164PhoneRegex, "Please enter a valid UK telephone number starting with +44")
      .notRequired()
  }
];

/**
 * Main "CreateUser" View
 *
 * @returns
 */
const CreateUserPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { terminology } = props;
  const [ createUserResponse, createUser ] = useUserApi("CREATE_USER");
  const formRef = React.useRef<Formik>(null);

  React.useEffect(() => {
    // On Success reset the form
    if (createUserResponse.data) {
      if (formRef.current) {
        formRef.current.resetForm();
      }
    }
  }, [ createUserResponse ]);

  return (
    <Layout {...props}>
      <FormWrapper>
        <Form
          ref={formRef}
          error={createUserResponse.error ? createUserResponse.error.message : null}
          submitting={createUserResponse.pending}
          fields={createUserForm()}
          onSubmit={({
            firstName, lastName, email, phoneNumber
          }) => createUser({
            firstName,
            lastName,
            email,
            phoneNumber,
            passwordAuthDisabled: false,
            roleId: 2
          })}
          submitButtonText={`Create ${terminology.user.singular.text}`}
        />
      </FormWrapper>
    </Layout>
  );
};

const FormWrapper = styled(Grid.Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.margins.xl};
  form {
    width: 400px;
  }
`;

export default CreateUserPage;
